import {
  FETCH_DEVICES,
  FETCH_DEVICES_SETTINGS,
  CLEAR_DEVICE_DASHBOARD_DATA,
  FETCH_SHIPMENT_DETAILS
} from '#action/types';

const defaultState = [];

export default function (state = defaultState, action) {
  switch (action.type) {
    case FETCH_DEVICES:
    case FETCH_SHIPMENT_DETAILS:
      // TODO: remove `location`
      return action.payload.map(d => ({
        ...d,
        location: d.lastLocation
      }));
    case FETCH_DEVICES_SETTINGS:
      return [
        ...state.map(deviceData => ({
          ...deviceData,
          settings: action.payload.find(
            i => deviceData.uid === i.uid
          )
        }))
      ];
    case CLEAR_DEVICE_DASHBOARD_DATA:
      return defaultState;
    default:
      return state;
  }
}
